<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <div class="table-operator"  style="margin-top: 5px">
        <a-button @click="flushPage" type="primary" icon="plus">{{ $t('flush') }}</a-button>
        <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('add') }}</a-button>
      </div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
        <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('edit') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
          <a class="ant-dropdown-link">
          {{ $t('more') }} <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm :title="$t('confirmDelete')" @confirm="() => handleDelete(record)">
                <a>{{ $t('delete') }}</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
      </div>
      <third-type-relation-edit-new ref="modalForm" :common-statuses='commonStatuses' :relation-types='relationTypes' :types='types' :field-name='fieldName' @ok="modalFormOk"></third-type-relation-edit-new>
    </div>
  </div>
</template>
<script>
import {
  relationListPre,
  relationOpt
} from '@/webpublicapi/teleMarket'
import ThirdTypeRelationEditNew from './modules/ThirdTypeRelationEditNew'
import {mapGetters} from "vuex";
const I18N_KEY = 'teleMarket.';
export default {
  name: 'TeleMarketThirdTypeRelation',
  components: {
    ThirdTypeRelationEditNew,
  },
  data () {
    return {
      I18N_KEY,
      loading: false,
      total: 0,
      commonStatuses: [],
      relationTypes: [],
      types: [],
      fieldName: 'textCn',
      name: null,
      visible: false,
      dataSource: [],
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
    // Table header
    columns () {
      return [
        {
          title: this.$t(I18N_KEY + 'relationName'),
          align:"center",
          dataIndex: 'name',
        },
        {
          title: this.$t(I18N_KEY + 'relationKey1'),
          align: 'center',
          dataIndex: 'key1',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.types) {
                if(text === this.types[i].value) {
                  return this.types[i][this.fieldName] + "(" + text + ")"
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'relationKey2'),
          align: 'center',
          dataIndex: 'key2',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.types) {
                if(text === this.types[i].value) {
                  return this.types[i][this.fieldName] + "(" + text + ")"
                }
              }
            } else {
              return '';
            }
          },
        },
        {
          title: this.$t(I18N_KEY + 'relationRate1'),
          align:"center",
          dataIndex: 'rate1',
        },
        {
          title: this.$t(I18N_KEY + 'relationRate2'),
          align:"center",
          dataIndex: 'rate2',
        },
        {
          title: this.$t(I18N_KEY + 'relationType'),
          align:"center",
          dataIndex: 'relation',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.relationTypes) {
                if(text == this.relationTypes[i].value) {
                  return this.relationTypes[i][this.fieldName]
                }
              }
            }
            return text;
          }
        },
        {
          title: this.$t(I18N_KEY + 'relationStatus'),
          align:"center",
          dataIndex: 'status',
          customRender: (text, record) => {
            var text = text;
            if(text != undefined && text != null && text != '') {
              for(var i in this.commonStatuses) {
                if(text == this.commonStatuses[i].value) {
                  return this.commonStatuses[i][this.fieldName]
                }
              }
            }
            return text;
          }
        },
        {
          title: this.$t(I18N_KEY + 'operate'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          scopedSlots: { customRender: 'action' },
        }]
    },
  },
  created () {
    this.loadBaseData();
  },
  methods: {
    loadBaseData(){
      this.loading = true;
      relationListPre({}).then((res) => {
        if (res.code === 1000) {
          this.types = res.data.types
          this.commonStatuses = res.data.commonStatuses
          this.dataSource = res.data.relations
          this.relationTypes = res.data.relationTypes
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false;
      }).catch(e => {
        this.$message.error(e.message);
        this.loading = false;
      })
    },
    searchQuery () {
      this.loadBaseData();
    },
    flushPage() {
      this.loadBaseData();
    },
    modalFormOk(data) {
      this.createSeat(data);
    },
    handleAdd () {
      this.name = undefined;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = "1";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit (record) {
      this.name = record.name;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "2";
      this.$refs.modalForm.disableSubmit = false;
    },
    handleDelete (record) {
      this.createSeat(record, "3");
    },
    changeModal (visible) {
      this.visible = visible;
    },
    createSeat (data, opt) {
      console.log(data)
      const form = {
        ...data,
        // name: this.name,
        opt: opt?opt:(this.name ? '2' : '1'),
      };
      console.log(form)
      // const requestField = this.versionId ? '2' : '1'
      relationOpt(form).then(res => {
        this.$refs.modalForm.closeLoading();
        this.$refs.modalForm.close();
        if (res.code === 1000) {
          this.$message.success(res.msg);
          this.loadBaseData();
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$refs.modalForm.closeLoading();
        this.$message.error(e.message);
      })
    },
  },
  watch: {
    languageStorage: {
      handler (lang) {
        if (lang == 'en-US') {
          this.fieldName = 'textEn';
        } else if (lang == 'es') {
          this.fieldName = 'textEs';
        } else {
          this.fieldName = 'textEn';
        }
      },
      immediate: true,
    }
  },
}
</script>
<style scoped>
@import '~@/assets/less/common.less';
</style>
